module.exports = __webpack_public_path__ + "fonts/fa-solid-900.d1e8a25.woff2";